<template>
  <div v-if-has-access="getRequiredAccesses()">
    <slot />
  </div>
</template>

<script>
    export default {
        name: "MetaPrivilegeChecker",
        props: {
          privilegeType: {
              type: String,
              default: 'DELETE'
            }
        },
        methods: {
          getRequiredAccesses() {
            if (this.privilegeType.toUpperCase() === 'DELETE') {

              return this.$route.meta.deletePrivileges;

            } else if (this.privilegeType.toUpperCase() === 'UPDATE') {

              return this.$route.meta.updatePrivileges;

            }
          }
        }
    }
</script>

<style scoped>

</style>
